import Cookies from 'js-cookie'
 
 
export function getToken (name) {
  return Cookies.get(name)
}
 
export function setToken (name,value) {
  return Cookies.set(name, value,{ expires: 7, path: '/'})
//   return Cookies.set(name, value,{ expires: 7, path: '' ,domain: ''})
}
 
export function removeToken (name) {
  return Cookies.remove(name)
}